/**
 * @typedef {(KNIGHT_DOWN_LEFT_LEFT | KNIGHT_DOWN_RIGHT_RIGHT | KNIGHT_UP_UP_LEFT | KNIGHT_UP_UP_RIGHT)} TypeAnimation An animation.
 */

/**
 * The 'KNIGHT_DOWN_LEFT_LEFT' animation.
 * @type {'knight-down-left-left'}
 * @constant
 */
const KNIGHT_DOWN_LEFT_LEFT = 'knight-down-left-left';

/**
 * The 'KNIGHT_DOWN_RIGHT_RIGHT' animation.
 * @type {'knight-down-right-right'}
 * @constant
 */
const KNIGHT_DOWN_RIGHT_RIGHT = 'knight-down-right-right';

/**
 * The 'KNIGHT_UP_UP_LEFT' animation.
 * @type {'knight-up-up-left'}
 * @constant
 */
const KNIGHT_UP_UP_LEFT = 'knight-up-up-left';

/**
 * The 'KNIGHT_UP_UP_RIGHT' animation.
 * @type {'knight-up-up-right'}
 * @constant
 */
const KNIGHT_UP_UP_RIGHT = 'knight-up-up-right';

export {

    KNIGHT_DOWN_LEFT_LEFT,
    KNIGHT_DOWN_RIGHT_RIGHT,
    KNIGHT_UP_UP_LEFT,
    KNIGHT_UP_UP_RIGHT
};
